<!--案例描述-->
<template>
  <el-dialog title="案例描述" class="addDialog" :visible.sync="Visible" width="11rem" style="min-width: 9.65rem;"
             :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div class="content-inner">
      <div class="container-t">
        <p class="container-title">案例要求</p>
        <div class="container-desc" v-html="describtion"></div>
      </div>

      <div class="container-b" v-show="scenarioName != '投研报告智能体'">
        <hr />
        <div class="container-title">案例流程</div>
        <div class="smpic">
          <img src="~@imgs/case/Group_304.png" v-show="casetype == 1" />
          <img src="~@imgs/case/Group_305.png" v-show="casetype == 2" />
        </div>
      </div>
      <div class="container-bb">
        <hr />
        <div class="container-title">附件下载</div>
        <div class="txt" v-if="filelist.length == 0">
          <span>无</span>
        </div>
        <div class="txt" v-else>
          <a class="fj" v-for="(item, index) in filelist" :key="index" @click="openfile(item)"
             style="margin-right: 15px;">
            {{ item.originalFileName }}
          </a>
        </div>
      </div>
    </div>
    <div class="footer-inner" slot="footer">
      <el-button type="primary" size="small" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import apiUser from "@/api/user";
export default {
  name: 'casedescDialog',
  props: {
    describtion () {
      return {
        type: String,
        default: ''
      }
    },
    casetype () {
      return {
        type: Number,
        default: 1
      }
    }
  },
  data () {
    return {
      scenarioName: '',
      Visible: false,
      filelist: [],
      HtUrl: window.HtUrl
    }
  },
  computed: {
  },
  watch: {

  },
  created () {
    this.scenarioName = sessionStorage.getItem('scenarioName')
    this.init()
  },
  mounted () {

  },
  methods: {
    openfile (data) {
      window.open(this.HtUrl + data.filePath, '_blank')
    },
    init () {
      let caseno = sessionStorage.getItem('caseno')
      if(caseno){
        apiUser.GetAttachment({
          caseId: sessionStorage.getItem('caseno'),
        }).then((res) => {
          console.log("res", res);
          if (res.data) {
            this.filelist = res.data || []
          }
        });
      }
    },
    show () {
      this.Visible = true
    },

    handleClose () {
      this.Visible = false
    },
  }
}
</script>

<style lang="less" scoped>
.addDialog {
  backdrop-filter: blur(5px);

  /deep/ .el-dialog {
    border: 1px solid rgba(29, 156, 181, 0.3);
    padding: 0 20px;
    border-radius: 10px;
    background-color: #fff;

    .el-dialog__headerbtn {
      font-size: 20px !important;
    }
  }

  .content-inner {
    height: 500px;
    overflow: auto;

    .container-t {
      .container-title {
        font-size: 16px;
        margin: 10px 0;
      }

      .container-desc {
        line-height: 1.5;
        text-indent: 2em;
      }
    }

    .container-b {
      .container-title {
        font-size: 16px;
        margin: 10px 0;
      }

      .smpic {
        width: 9.55rem;
        height: 2.95rem;

        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }

    .container-bb {
      .container-title {
        font-size: 16px;
        margin: 10px 0;
      }

      .txt {
        margin: 0.1rem 0;

        .fj {
          color: #7b6af6;
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }

  }

  .footer-inner {
    text-align: center;

    .el-button {
      min-width: 120px;
      letter-spacing: 2px;
    }
  }
}

/**
 * -------------------------------------------------------
 * 滚动条
 * -------------------------------------------------------
 */
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  box-shadow: inset 0 0 10px -2px #ffffff;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  /*background: #ddd;*/
}
</style>